import React from 'react';
import { Box, Typography, Button, Modal, Paper, Dialog, Alert, useMediaQuery } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Banner = ({
  headerText = 'Book your session with a Registered Dietitian!',
  bodyText = 'In order to complete your application for Medically-Tailored Food, you must meet with one of our dietitians to review your Diet Quality Results',
  CTA = 'Schedule Now',
}) => {
  const isMobile = useMediaQuery('(max-width: 600px)');

  const getBackgroundColor = (severity) => {
    switch (severity) {
      case 'success':
        return 'white';
      case 'info':
        return 'white';
      case 'warning':
        return 'white';
      case 'error':
        return 'white';
      default:
        return 'white';
    }
  };

  return (
    <Alert
      id="banner-container"
      sx={{
        display: 'flex',
        width: isMobile ? '80%' : '60%',
        padding: '6px 16px',
        alignItems: 'flex-start',
        borderRadius: '4px',
        border: '1px solid #EF6C00',
        position: 'relative',
        // backgroundColor: getBackgroundColor('warning'),
      }}
      severity="warning"
    >
      {/* <Box
        id="icon-container-container"
        sx={{
          display: 'flex',
          padding: '7px 12px 7px 0px',
          alignItems: 'flex-start',
        }}
      >
        <Box
          id="icon-container"
          sx={{
            display: 'flex',
            width: '22px',
            height: '22px',
            alignItems: 'flex-start',
          }}
        >
          <WarningAmberIcon
            sx={{
              flex: '1 0 0',
              alignSelf: 'stretch',
            }}
          />
        </Box>
      </Box> */}
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          flex: 1,
        }}
      >
        <Box
          id="text-container"
          sx={{
            display: 'flex',
            padding: isMobile ? '0px 0px 30px 0px' : '0px 0px 20px 0px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '4px',
            flex: '1 0 0',
          }}
        >
          <Typography
            sx={{
              alignSelf: 'stretch',
              color: '#663C00',
              fontFamily: 'Montserrat',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '150%',
              letterSpacing: '0.15px',
            }}
          >
            {headerText}
          </Typography>
          <Typography
            sx={{
              alignSelf: 'stretch',
              color: '#663C00',
              fontFamily: 'Montserrat',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '143%',
              letterSpacing: '0.17px',
            }}
          >
            {bodyText}
          </Typography>
        </Box>
        <Box
          id="action-container"
          sx={{
            display: 'flex',
            padding: '4px 0px 0px 16px',
            alignItems: 'flex-start',
            position: isMobile ? 'absolute' : 'static',
            bottom: isMobile ? '10px' : 'auto',
            right: isMobile ? '10px' : 'auto',
          }}
        >
          <Button
            sx={{
              display: 'flex',
              padding: '4px 10px',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '4px',
              background: '#211551',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Typography
                sx={{
                  color: '#FFF',
                  fontFamily: 'Montserrat',
                  fontSize: '13px',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: '22px',
                  letterSpacing: '0.46px',
                  textTransform: 'uppercase',
                }}
              >
                {CTA}
              </Typography>
              <Box
                id="cta-icon-container"
                sx={{
                  display: 'flex',
                  height: '18px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <ArrowForwardIcon
                  sx={{
                    color: '#FFF',
                    width: '18px',
                    height: '18px',
                    flexShrink: '0',
                  }}
                />
              </Box>
            </div>
          </Button>
        </Box>
      </div>
    </Alert>
  );
};

export default Banner;
